import React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';

import Typography from '@ts-core/components/Typography';

const ThreadStats = (props) => {
  const { loading, thread } = props;

  function renderStat(value, title) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        ml={{ xs: 1, md: 3 }}
        minWidth={45}
      >
        <Typography
          loading={loading}
          variant="h6"
          skeletonWidth="25%"
          skeletonHeight={32}
        >
          {value}
        </Typography>
        <Typography
          loading={loading}
          variant="caption"
          skeletonWidth="50%"
          skeletonHeight={8}
        >
          {title}
        </Typography>
      </Box>
    );
  }

  return (
    <Box display="flex" flexDirection="row" alignItems="center">
      {renderStat(thread?.score, thread?.score === 1 ? 'voto' : 'votos')}
      {renderStat(
        thread?.answersCount,
        thread?.answersCount === 1 ? 'respuesta' : 'respuestas'
      )}
      {renderStat(thread?.views, thread?.views === 1 ? 'visita' : 'visitas')}
    </Box>
  );
};

ThreadStats.propTypes = {
  loading: PropTypes.bool,
  thread: PropTypes.object,
};

ThreadStats.defaultProps = {
  loading: false,
  thread: {},
};

export default ThreadStats;
